import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const getStrategyById = async (endpoint, tableName, PK, SK) => {
  try {
    const url = PK && SK ? `${baseUrl}${endpoint}/${PK}/${SK}` : `${baseUrl}${endpoint}`
    const response = await axios.get(url, {
      params: PK && SK ? {} : { table: tableName }, // Params are only needed for fetching all items
    })
    if (response.status === 204) {
      return { data: PK && SK ? {} : [], status: 204 }
    } else {
      return response.data || []
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    return [] // Return an empty array in case of an error
  }
}

export const useStrategy = (PK?: string, SK?: string, queryKey = ['strategy', PK, SK]) => {
  const { data: strategy, isLoading, isError } = useQuery({
    queryKey: queryKey, // Use consistent query key
    queryFn: () => getStrategyById('/aws/strategy', 'strategy', PK, SK),
    staleTime: Infinity, // Optional: adjust based on your caching needs
    gcTime: 1000 * 60 * 10, // Cache data for 10 minutes
    enabled: !!PK && !!SK, // Only fetch if dealId is provided
  })

  // Return in the same format as the original hook
  return { strategy, isLoading, isError }
}
